import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { fromNewDateFormatToDDMMYYYYSlash } from '../../Helpers/dateHelper'

export default function MaterialCorrectionDrawer(props) {
    const classes = useStyles();

    const { t } = useTranslation();
    const rows = props.quantitiesAssigned.filter(x => props.productionOrder.bomIn.some(y => y.productId === JSON.parse(x.metaData).find(x => x.MetaDataType === 1).MetaData[0].ProductId)).sort((a, b) => new Date(b.insertedOn) - new Date(a.insertedOn)).map(q => {
        var metaData = JSON.parse(q.metaData).find(x => x.MetaDataType === 1).MetaData[0]
        return (createData(q.quantityAssigned, metaData, q.insertedOn, q.id)
        )
    }
    )
    function createData(quantity, metaData, inserted, id) {
        let product = props.productionOrder.bomIn.find(x => x.productId === metaData.ProductId).productName
        let silo = metaData.Silo
        let purchaseOrderNumber = metaData.PurchaseOrderNumber
        return { product, silo, quantity, inserted, purchaseOrderNumber, id };
    }


    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.draweropen} classes={{ paper: clsx({ [classes.drawerOpen]: props.draweropen, [classes.drawerClose]: !props.draweropen, }), }} onClose={() => props.opendrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{t("Material correction")}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.opendrawer(false)}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <div>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>Product</TableCell>
                            <TableCell className={classes.headCell}>{t("Purchase order n°")}</TableCell>
                            <TableCell className={classes.headCell}>Silo</TableCell>
                            <TableCell className={classes.headCell}>{t("Quantity")}</TableCell>
                            <TableCell className={classes.headCell} align="right">{t("Assigned at machine")}</TableCell>
                            <TableCell className={classes.headCell}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.id} className={classes.row}>
                                <TableCell className={classes.infoCell}>{row.product}</TableCell>
                                <TableCell className={classes.infoCell}>{row.purchaseOrderNumber}</TableCell>
                                <TableCell className={classes.infoCell}>{row.silo}</TableCell>
                                <TableCell className={classes.infoCell}>{row.quantity} kg</TableCell>
                                <TableCell className={classes.infoCell} align="right">{fromNewDateFormatToDDMMYYYYSlash(row.inserted)}</TableCell>
                                <TableCell className={classes.infoCell}><button className={classes.deleteButton} onClick={() => props.openDeleteQuantitiesDialog(row.id)}><DeleteIcon className={classes.deleteIcon}></DeleteIcon></button></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "95%",
        padding: "40px",
        paddingTop: "0px",
        paddingLeft: "20px",
    },
    closeButton: {
        float: "right",
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "36px !important",
        height: "36px !important",
        minWidth: "36px !important",
        marginTop: "10px"
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "40%",
        backgroundColor: "#EFEFEF",
    },
    drawerClose: {
        width: 0
    },
    header: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        width: "100%",
        height: '70px',
        display: "block"
    },
    title: {
        width: "80%",
        float: 'left',
        marginTop: "20px",
    },
    infoCell: {
        padding: "10px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "white",
        },
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
        border: "none",
    },

    deleteButton: {
        border: "none",
        outline: 'none',
        backgroundColor: "rgb(1,1,1,0.0)",
        cursor: "pointer",
        float: "right"
    },
    deleteIcon: {
        height: "25px",
        width: "25px",
        color: FlagstoneTheme.palette.primary.main,
    },
    table: {
        height: "90%"
    }
}));